import { createSelector } from 'reselect';
import { selectActiveServiceId, selectIsPromotionPackageSelected } from '../publishTerms';
import { selectIsAuctionEnabled } from './selectIsAuctionEnabled';
import { EServiceId } from '../../types/reducers/publishTerms';

export const selectIsAuctionSelected = createSelector(
  [selectIsAuctionEnabled, selectIsPromotionPackageSelected, selectActiveServiceId],
  (isAuctionEnabled, isPromotionPackageSelected, activeServiceId): boolean => {
    const isAuctionForServiceEnabled = activeServiceId === EServiceId.top;

    return isAuctionEnabled && (isPromotionPackageSelected || isAuctionForServiceEnabled);
  },
);
